









import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import UserInterface2FolderDataTable from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-2-folder-data-table.vue'

import {
  DataTableFile,
  itemTypeDescriptionList
} from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

import {
  BASIC_DESCRIPTION,
  TRANSACTION_RESOURCE_CENTER_DESCRIPTION,
  PRODUCT_RESOURCE_CENTER_DESCRIPTION,
  JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION,
  CURRENCY_EXCHANGE_RESOURCE_CENTER_DESCRIPTION,
  DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_CENTER_DESCRIPTION
} from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-3-constants/constants-1-account-description'


const namespace = 'digitalCurrency'

@Component({
  components: {
    UserInterface2FolderDataTable
  }
})
class AccountResourceItem1AccountDescription extends Vue {

  @Prop({ default: '' }) accountId?: string

  @Getter('getDigitalCurrencyAccount', { namespace }) getDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyAccountDescription', { namespace }) getDigitalCurrencyAccountDescription?: any

  get getDataTableInitialFile () {

    const digitalCurrencyAccount = this.getDigitalCurrencyAccount(this.accountId)
    const accountBasicDescription = this.getDigitalCurrencyAccountDescription(this.accountId, BASIC_DESCRIPTION)

    const initialFile = new DataTableFile()

    const fileForAccountDescriptionBasicDescription: DataTableFile = {
      itemType: itemTypeDescriptionList,
      itemId: BASIC_DESCRIPTION,
      itemName: 'Basic Description',
      itemIconImageUrl: 'person',
      itemData: {
        descriptionListItemList: [{
          propertyName: 'Account Id',
          propertyIconId: 'person',
          propertyValue: digitalCurrencyAccount.accountId
        }, {
          propertyName: 'Account Name',
          propertyIconId: 'person',
          propertyValue: digitalCurrencyAccount.accountName
        }, {
          propertyName: 'Account Username',
          propertyIconId: 'person',
          propertyValue: ``,
          propertyValueAsHtml: `<a href="${location.href}${digitalCurrencyAccount.accountUsername}" target="_blank" class="router-link">${digitalCurrencyAccount.accountUsername}</a>`
        }, {
          propertyName: 'Account Minimum Description',
          propertyIconId: 'message',
          propertyValue: accountBasicDescription.accountMinimumDescription
        }, {
          propertyName: 'Account Median Description',
          propertyIconId: 'message',
          propertyValue: accountBasicDescription.accountMedianDescription
        }, {
          propertyName: 'Account Phone Number',
          propertyIconId: 'phone',
          propertyValue: accountBasicDescription.phoneNumber
        }, {
          propertyName: 'Account Website URL',
          propertyIconId: 'public',
          propertyValue: accountBasicDescription.homeWebsiteAddress
        }, {
          propertyName: 'Account Email Address',
          propertyIconId: 'mail_outline',
          propertyValue: accountBasicDescription.emailAddress
        }, {
          propertyName: 'Account Physical Address By Street Name And House Number',
          propertyIconId: 'location_on',
          propertyValue: accountBasicDescription.physicalLocationAddress.streetAndHouseNumber
        }, {
          propertyName: 'Account Physical Address By City',
          propertyIconId: 'location_on',
          propertyValue: accountBasicDescription.physicalLocationAddress.cityTownName
        }, {
          propertyName: 'Account Physical Address By State',
          propertyIconId: 'location_on',
          propertyValue: accountBasicDescription.physicalLocationAddress.stateProvinceName
        }, {
          propertyName: 'Account Physical Address By Zip Code',
          propertyIconId: 'location_on',
          propertyValue: accountBasicDescription.physicalLocationAddress.zipCode
        }, {
          propertyName: 'Account Physical Address By Country',
          propertyIconId: 'location_on',
          propertyValue: accountBasicDescription.physicalLocationAddress.countryName
        }, ...(accountBasicDescription.socialMediaAccountList || []).map((socialMediaAccountListItem: any) => {
          return {
            propertyName: socialMediaAccountListItem.propertyName,
            propertyIconId: 'groups',
            propertyValue: socialMediaAccountListItem.propertyValue
          }
        }), ...(accountBasicDescription.generalUserDescriptionList || []).map((userDescriptionListItem: any) => {
          return {
            propertyName: userDescriptionListItem.propertyName,
            propertyIconId: 'info_outline',
            propertyValue: userDescriptionListItem.propertyValue
          }
        })]
      }
    }

    const accountDescriptionForTransactionResourceCenterDescription = this.getDigitalCurrencyAccountDescription(this.accountId, TRANSACTION_RESOURCE_CENTER_DESCRIPTION)

    const fileForAccountDescriptionTransactionResourceCenterDescription: DataTableFile = {
      itemType: itemTypeDescriptionList,
      itemId: TRANSACTION_RESOURCE_CENTER_DESCRIPTION,
      itemName: 'Transaction Resource Center Description',
      itemIconImageUrl: 'description',
      itemData: {
        descriptionListItemList: [{
          propertyName: 'Places Where Transactions Are Accepted From',
          propertyIconId: 'location_on',
          propertyValue: accountDescriptionForTransactionResourceCenterDescription.placesWhereTransactionsAreAcceptedFrom
        }, {
          propertyName: 'Willing To Receive Promotions',
          propertyIconId: 'attach_money',
          propertyValue: `${accountDescriptionForTransactionResourceCenterDescription.willingToReceivePromotions}`
        }, {
          propertyName: 'Willing To Receive Promotions of Type',
          propertyIconId: 'attach_money',
          propertyValue: accountDescriptionForTransactionResourceCenterDescription.willingToReceivePromotionsOfType
        }, ...(accountDescriptionForTransactionResourceCenterDescription.generalUserDescriptionList || []).map((userDescriptionListItem: any) => {
          return {
            propertyName: userDescriptionListItem.propertyName,
            propertyIconId: 'info_outline',
            propertyValue: userDescriptionListItem.propertyValue
          }
        })]
      }
    }

    const accountDescriptionForProductResourceCenterDescription = this.getDigitalCurrencyAccountDescription(this.accountId, PRODUCT_RESOURCE_CENTER_DESCRIPTION)

    const fileForAccountDescriptionProductResourceCenterDescription: DataTableFile = {
      itemType: itemTypeDescriptionList,
      itemId: PRODUCT_RESOURCE_CENTER_DESCRIPTION,
      itemName: 'Product Resource Center Description',
      itemIconImageUrl: 'shopping_bag',
      itemData: {
        descriptionListItemList: [{
          propertyName: 'Business Description',
          propertyIconId: 'business',
          propertyValue: accountDescriptionForProductResourceCenterDescription.businessDescription
        }, {
          propertyName: 'Product Genre List',
          propertyIconId: 'shopping_bag',
          propertyValue: accountDescriptionForProductResourceCenterDescription.productGenreList
        }, {
          propertyName: 'Estimated Time To Deliver Product',
          propertyIconId: 'watch_later',
          propertyValue: accountDescriptionForProductResourceCenterDescription.estimatedTimeToDeliverProduct
        }, {
          propertyName: 'Willing To Receive Promotions',
          propertyIconId: 'attach_money',
          propertyValue: `${accountDescriptionForProductResourceCenterDescription.willingToReceivePromotions}`
        }, {
          propertyName: 'Willing To Receive Promotions of Type',
          propertyIconId: 'attach_money',
          propertyValue: accountDescriptionForProductResourceCenterDescription.willingToReceivePromotionsOfType
        }, ...(accountDescriptionForProductResourceCenterDescription.generalUserDescriptionList || []).map((userDescriptionListItem: any) => {
          return {
            propertyName: userDescriptionListItem.propertyName,
            propertyIconId: 'info_outline',
            propertyValue: userDescriptionListItem.propertyValue
          }
        })]
      }
    }

    const accountDescriptionForJobEmploymentResourceCenterDescription = this.getDigitalCurrencyAccountDescription(this.accountId, JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION)

    const fileForAccountDescriptionJobEmploymentResourceCenterDescription: DataTableFile = {
      itemType: itemTypeDescriptionList,
      itemId: JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION,
      itemName: 'Job Employment Resource Center Description',
      itemIconImageUrl: 'work_outline',
      itemData: {
        descriptionListItemList: [{
          propertyName: 'Company Work Culture',
          propertyIconId: 'people',
          propertyValue: accountDescriptionForJobEmploymentResourceCenterDescription.companyWorkCulture
        }, {
          propertyName: 'Currently Hiring Position List',
          propertyIconId: 'work_outline',
          propertyValue: accountDescriptionForJobEmploymentResourceCenterDescription.currentlyHiringPositionList
        }, {
          propertyName: 'Estimated Time to Hire',
          propertyIconId: 'watch_later',
          propertyValue: accountDescriptionForJobEmploymentResourceCenterDescription.estimatedTimeToHire
        }, {
          propertyName: 'Willing To Receive Promotions',
          propertyIconId: 'attach_money',
          propertyValue: `${accountDescriptionForJobEmploymentResourceCenterDescription.willingToReceivePromotions}`
        }, {
          propertyName: 'Willing To Receive Promotions of Type',
          propertyIconId: 'attach_money',
          propertyValue: accountDescriptionForJobEmploymentResourceCenterDescription.willingToReceivePromotionsOfType
        }, ...(accountDescriptionForJobEmploymentResourceCenterDescription.generalUserDescriptionList || []).map((userDescriptionListItem: any) => {
          return {
            propertyName: userDescriptionListItem.propertyName,
            propertyIconId: 'info_outline',
            propertyValue: userDescriptionListItem.propertyValue
          }
        })]
      }
    }

    const accountDescriptionForCurrencyExchangeResourceCenterDescription = this.getDigitalCurrencyAccountDescription(this.accountId, CURRENCY_EXCHANGE_RESOURCE_CENTER_DESCRIPTION)

    const fileForAccountDescriptionCurrencyExchangeResourceCenterDescription: DataTableFile = {
      itemType: itemTypeDescriptionList,
      itemId: CURRENCY_EXCHANGE_RESOURCE_CENTER_DESCRIPTION,
      itemName: 'Currency Exchange Resource Center Description',
      itemIconImageUrl: 'transfer_within_a_station',
      itemData: {
        descriptionListItemList: [{
          propertyName: 'Currency Exchange Description',
          propertyIconId: 'business',
          propertyValue: accountDescriptionForCurrencyExchangeResourceCenterDescription.currencyExchangeDescription
        }, {
          propertyName: 'Currency Trade List',
          propertyIconId: 'attach_money',
          propertyValue: accountDescriptionForCurrencyExchangeResourceCenterDescription.currencyTradeList
        }, {
          propertyName: 'Estimated Time to Deliver Trade Payout',
          propertyIconId: 'watch_later',
          propertyValue: accountDescriptionForCurrencyExchangeResourceCenterDescription.estimatedTimeToDeliverTradePayout
        }, {
          propertyName: 'Willing To Receive Promotions',
          propertyIconId: 'attach_money',
          propertyValue: `${accountDescriptionForCurrencyExchangeResourceCenterDescription.willingToReceivePromotions}`
        }, {
          propertyName: 'Willing To Receive Promotions of Type',
          propertyIconId: 'attach_money',
          propertyValue: accountDescriptionForCurrencyExchangeResourceCenterDescription.willingToReceivePromotionsOfType
        }, ...(accountDescriptionForCurrencyExchangeResourceCenterDescription.generalUserDescriptionList || []).map((userDescriptionListItem: any) => {
          return {
            propertyName: userDescriptionListItem.propertyName,
            propertyIconId: 'info_outline',
            propertyValue: userDescriptionListItem.propertyValue
          }
        })]
      }
    }

    const accountDescriptionForDigitalCurrencyAlternativeResourceCenterDescription = this.getDigitalCurrencyAccountDescription(this.accountId, DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_CENTER_DESCRIPTION)

    const fileForAccountDescriptionDigitalCurrencyAlternativeResourceCenterDescription: DataTableFile = {
      itemType: itemTypeDescriptionList,
      itemId: DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_CENTER_DESCRIPTION,
      itemName: 'Digital Currency Alternative Resource Center Description',
      itemIconImageUrl: 'public',
      itemData: {
        descriptionListItemList: [{
          propertyName: 'Business Description',
          propertyIconId: 'business',
          propertyValue: accountDescriptionForDigitalCurrencyAlternativeResourceCenterDescription.businessDescription
        }, {
          propertyName: 'Business Feature List',
          propertyIconId: 'list',
          propertyValue: accountDescriptionForDigitalCurrencyAlternativeResourceCenterDescription.businessFeatureList
        }, {
          propertyName: 'Business Website URL',
          propertyIconId: 'public',
          propertyValue: accountDescriptionForDigitalCurrencyAlternativeResourceCenterDescription.businessWebsiteUrl
        }, {
          propertyName: 'Representative of An Alternative Digital Currency?',
          propertyIconId: 'person',
          propertyValue: `${accountDescriptionForDigitalCurrencyAlternativeResourceCenterDescription.doesRepresentDigitalCurrencyAlternative}`
        }, {
          propertyName: 'Willing To Receive Promotions',
          propertyIconId: 'attach_money',
          propertyValue: `${accountDescriptionForDigitalCurrencyAlternativeResourceCenterDescription.willingToReceivePromotions}`
        }, {
          propertyName: 'Willing To Receive Promotions of Type',
          propertyIconId: 'attach_money',
          propertyValue: accountDescriptionForDigitalCurrencyAlternativeResourceCenterDescription.willingToReceivePromotionsOfType
        }, ...(accountDescriptionForCurrencyExchangeResourceCenterDescription.generalUserDescriptionList || []).map((userDescriptionListItem: any) => {
          return {
            propertyName: userDescriptionListItem.propertyName,
            propertyIconId: 'info_outline',
            propertyValue: userDescriptionListItem.propertyValue
          }
        })]
      }
    }

    initialFile.fileVariableTable![fileForAccountDescriptionBasicDescription.itemId] = fileForAccountDescriptionBasicDescription
    initialFile.fileVariableTable![fileForAccountDescriptionTransactionResourceCenterDescription.itemId] = fileForAccountDescriptionTransactionResourceCenterDescription
    initialFile.fileVariableTable![fileForAccountDescriptionProductResourceCenterDescription.itemId] = fileForAccountDescriptionProductResourceCenterDescription
    initialFile.fileVariableTable![fileForAccountDescriptionJobEmploymentResourceCenterDescription.itemId] = fileForAccountDescriptionJobEmploymentResourceCenterDescription
    initialFile.fileVariableTable![fileForAccountDescriptionCurrencyExchangeResourceCenterDescription.itemId] = fileForAccountDescriptionCurrencyExchangeResourceCenterDescription
    initialFile.fileVariableTable![fileForAccountDescriptionDigitalCurrencyAlternativeResourceCenterDescription.itemId] = fileForAccountDescriptionDigitalCurrencyAlternativeResourceCenterDescription

    return initialFile
  }
}

export default AccountResourceItem1AccountDescription


